import { Box, Drawer } from '@mui/material'
import SchedulingCourseSessionsForm from './Form'
import SchedulingCourseSessionsFormAddTeacher from './AddTeacher'
import SchedulingCourseSessionsFormAddStudent from './AddStudent'
import { get } from 'store/scheduling/course-session'
import { useNavigate, useParams } from 'react-router-dom'
import { BasePathProvider } from 'components/Providers'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { save } from 'store/scheduling/course-session'
import { reset as resetSchedule } from 'store/scheduling/course-session-schedule'

const initialValues = {
  courseSession: {
    name: null,
    credit: null,
    quota: null,
    course: {
      id: null,
      name: null,
    },
    markingPeriods: null,
    courseLevelId: null,
    gradeSectionId: null,
    roomId: null
  },
}

export default function SchedulingCourseSessionsFormIndex() {
  const { courseSessionId, add } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const academicYearMarkingPeriods = useSelector(state => state.session?.academicYear?.markingPeriods)

  const courseSession = useSelector(state => state.scheduling.courseSession.list)?.find(
    item => item.id === +courseSessionId,
  )

  const basePath = `/scheduling/course-sessions/`

  useEffect(() => {
    if (+courseSessionId) {
      dispatch(resetSchedule())
      dispatch(get({ id: courseSessionId }))
    }
  }, [courseSessionId])

  const schema = yup.object().shape({
    courseSession: yup.object().shape({
      name: yup.string().nullable().required('Name is required'),
      credit: yup.number().nullable().required("Credit is required"),
      courseLevelId: yup.mixed().nullable().required("Course Level is required"),
    }),
  })

  const { control, handleSubmit, getValues, reset, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: courseSession && courseSession.id !== 'new'
      ? {
          courseSession: { ...courseSession },
        }
      : { ...initialValues },
  })

  useEffect(() => {
    if (!courseSession) return

    const aligned =
      academicYearMarkingPeriods && courseSession.markingPeriods
        ? (() => {
            const selected = new Set(courseSession.markingPeriods.map(mp => String(mp?.id)))
            return academicYearMarkingPeriods.map(mp => (selected.has(String(mp?.id)) ? mp : null))
          })()
        : courseSession.markingPeriods

    reset({ courseSession: { ...courseSession, markingPeriods: aligned } })
  }, [courseSession, academicYearMarkingPeriods, reset])

  const onSubmitSessionDetails = async () => {
    const data = getValues('courseSession')
    const markingPeriods = []

    data?.markingPeriods?.forEach(mp => {
      if (mp.id) markingPeriods.push(mp.id)
    })

    const payload = {
      courseId: data?.course.id,
      name: data?.name,
      credit: data?.credit ? +data?.credit : null,
      markingPeriods,
      quota: data?.quota ? +data?.quota : null,
      gradeSectionId: data?.gradeSectionId ? +data?.gradeSectionId : null,
      roomId: data?.roomId,
      courseLevelId: data?.courseLevelId,
    }
    if (+courseSessionId) {
      delete payload.courseId
      const res = await dispatch(save({ id: +courseSessionId, ...payload }))
      return !!res.payload
    } else {
      const res = await dispatch(save({ ...payload }))
      if (res.payload) {
        navigate(`${basePath}${res.payload.id}/`, { state: { initialStep: 1 } })
      }
      return false
    }
  }

  const onErrors = errors => console.log(errors)

  if (+courseSessionId && !courseSession) return null

  return (
    <BasePathProvider value={`${basePath}${courseSessionId}/`}>
      <Box>
        <SchedulingCourseSessionsForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          onSubmitSessionDetails={onSubmitSessionDetails}
          handleSubmit={handleSubmit}
          onErrors={onErrors}
        />
        <Drawer
          PaperProps={{
            sx: {
              width: 600,
            },
          }}
          open={Boolean(add)}
          anchor="right"
          onClose={() => navigate(`${basePath}${courseSessionId}/`)}
        >
          {add === 'teacher' && <SchedulingCourseSessionsFormAddTeacher />}
          {add === 'student' && <SchedulingCourseSessionsFormAddStudent control={control} />}
        </Drawer>
      </Box>
    </BasePathProvider>
  )
}
